import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Cases from './components/Cases';
import Process from './components/Process';
import Contact from './components/Contact';
import MobileStickyCTA from './components/MobileStickyCTA';
import Footer from './components/Footer';
import FounderProfile from './components/FounderProfile';
import DirectorProfile from './components/DirectorProfile';
import AssociateProfile from './components/AssociateProfile';

// M&A Premium Section Components
import MAHero from './components/MAService/MAHero';
import MAOfferings from './components/MAService/MAOfferings';
import MATimeline from './components/MAService/MATimeline';
import MAWhyUs from './components/MAService/MAWhyUs';
import MACases from './components/MAService/MACases';
import MAFinalCTA from './components/MAService/MAFinalCTA';

function App() {
  return (
    <div className="relative min-h-screen bg-brand-white">
      <Navbar />
      <main>
        {/* Core General Consulting Sections (Light Theme) */}
        <Hero />
        <About />
        
        {/* Leadership Division */}
        <div id="leadership">
          <FounderProfile />
          <DirectorProfile />
          <AssociateProfile />
        </div>

        <Services />
        <Cases />
        <Process />

        {/* Premium M&A Advisory Expansion (Sophisticated Dark/Gold Theme) */}
        <div id="ma-division" className="border-t-4 border-brand-gold">
          <MAHero />
          <MAOfferings />
          <MATimeline />
          <MAWhyUs />
          <MACases />
          <MAFinalCTA />
        </div>

        {/* Closing Sections */}
        <Contact />
      </main>
      <Footer />
      <MobileStickyCTA />
    </div>
  );
}

export default App;